import SchengenService from '@/visa-application/services/schengen/schengen.service';
import {
  PROJECT_NAME,
  GLOBAL_FILTER,
  LOCAL_COUNTRY,
  ALL_COUNTRY_CODE,
  IS_FRANCE_CLIENT,
  TLSCITIZEN_WEBAPP_URL,
  DIRECTUS_V9_URL
} from '@/constants';
import _ from 'lodash';
import axios from 'axios';
import VisaTypeCMSModel from '@/visa-application/models/VisaTypeCMSModel';

export function seoUrlFrom(text: string) {
  return text
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, '-')
    .toLowerCase()
    .replace(/&/g, '-and-')
    .replace(/[^a-z0-9\-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-*/, '')
    .replace(/-*$/, '');
}

export function isValidEmail(text: string): boolean {
  return /^[a-z0-9_.-]+@[a-z0-9_-]+\.[a-z0-9-]{2,16}(\.[a-z]{2,3})*$/i.test(text);
}

export function confirmPostalAction(forms, client: string, issuer: string) {
  const schengenService = new SchengenService();
  schengenService.getUserInfo(client, issuer).then(user => {
    const actionInfo = [];
    forms.forEach(form => {
      actionInfo.push({
        a_form: form.f_id,
        a_what: 'postapp_send',
        a_who: user.u_id,
        a_comment: 'Postal application',
        a_xref_u_login: user.u_email,
        a_occurence: 1
      });
    });
    schengenService.createMultiActions(client, JSON.stringify(actionInfo)).catch(error => {
      console.log(error);
    });
  });
}

export async function checkGroupAmendAppointment(client: string, issuer: string, fgId: number, isSchengenCsl: boolean) {
  const schengenService = new SchengenService();

  return new Promise<any>(async (resolve, reject) => {
    await schengenService
      .checkGroupAmendAppointmentButton(issuer, fgId, isSchengenCsl)
      .then(response => resolve(response))
      .catch(error => reject(error));
  });
}

export function showUsername(form): string {
  const f_pers_surnames = form.hasOwnProperty('f_pers_surnames') ? form.f_pers_surnames : '';
  const f_pers_givennames = form.hasOwnProperty('f_pers_givennames') ? form.f_pers_givennames : '';
  return f_pers_surnames + ' ' + f_pers_givennames;
}

export function getToday() {
  const today = new Date();
  return (
    today.getFullYear().toString() +
    '-' +
    (today.getMonth() > 8 ? today.getMonth() + 1 : '0' + (today.getMonth() + 1)) +
    '-' +
    (today.getDate() > 9 ? today.getDate() : '0' + today.getDate())
  );
}

export function getLocalStorage(key: string) {
  return localStorage.getItem(PROJECT_NAME + '_' + key);
}

export function setLocalStorage(key: string, value: any) {
  return localStorage.setItem(PROJECT_NAME + '_' + key, value);
}

export function removeLocalStorage(key: string) {
  return localStorage.removeItem(PROJECT_NAME + '_' + key);
}

export function getSessionStorage(key: string) {
  return sessionStorage.getItem(PROJECT_NAME + '_' + key);
}

export function setSessionStorage(key: string, value: any) {
  sessionStorage.setItem(PROJECT_NAME + '_' + key, value);
}

export function removeSessionStorage(key: string) {
  sessionStorage.removeItem(PROJECT_NAME + '_' + key);
}

export function filterDataByCountryAndIssuer(issuer: string, country: string, contentSlots) {
  _.remove(contentSlots, contentSlot => {
    const tags = _.map(
      _.union(contentSlot.tag)
        .toString()
        .toUpperCase()
        .split(','),
      _.trim
    );
    return (
      _.indexOf(tags, issuer.toUpperCase()) === -1 &&
      _.indexOf(tags, country.toUpperCase()) === -1 &&
      _.indexOf(tags, GLOBAL_FILTER.toUpperCase()) === -1
    );
  });
  return contentSlots;
}
export function filterDirectusDataByTag(filter: string, contentSlots) {
  _.remove(contentSlots, contentSlot => {
    const tags = _.map(
      _.union(contentSlot.tag)
        .toString()
        .toUpperCase()
        .split(','),
      _.trim
    );
    return _.indexOf(tags, filter.toUpperCase()) === -1;
  });
  return contentSlots;
}

export function filterDataByCountryAndIssuerAndUniqByTitle(issuer: string, country: string, contentSlots) {
  return _.uniqBy(filterDataByCountryAndIssuer(issuer, country, contentSlots), 'title');
}

export function getQueryVariable(variable) {
  const query = window.location.search.substring(1);
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  return '';
}

export function checkCountryCodeAndIssuerIsAvailable(code, type = 'country'): boolean {
  if (type === 'country') {
    return code.trim().length === 2;
  }
  if (type === 'issuer') {
    return (
      (code.substr(6) === LOCAL_COUNTRY || LOCAL_COUNTRY.endsWith(code.substr(6))) &&
      code.indexOf('2') === 5 &&
      (code.length === 8 || (code.length >= 8 && code.length <= 13))
    );
  }
}

export function getLaterDate(timeStr, addHours): string {
  const initialTime = new Date(timeStr);
  const finallyTime = new Date(initialTime.setHours(initialTime.getHours() + Number(addHours)));
  return (
    finallyTime.getFullYear() +
    '-' +
    add0(finallyTime.getMonth() + 1) +
    '-' +
    add0(finallyTime.getDate()) +
    ' ' +
    add0(finallyTime.getHours()) +
    ':' +
    add0(finallyTime.getMinutes())
  );
}
export function GetCurrentDate(timeStr): string {
  const initialTime = new Date(timeStr);
  return initialTime.getFullYear() + '-' + add0(initialTime.getMonth() + 1) + '-' + add0(initialTime.getDate());
}

export function add0(m) {
  return m < 10 ? '0' + m : m;
}

export function replaceAllOccurrenceOfADetailCode(text: string, code: string, replaceBy: string): string {
  if (typeof text !== 'string' || !text.trim()) {
    return text;
  }
  const regexp: RegExp = new RegExp('{{[\\s]*' + code + '[\\s]*}}', 'gi');
  if (replaceBy) {
    return text.replace(regexp, replaceBy);
  }
  return text.replace(regexp, '');
}

export function getCmsDataByCountryAndDefault(cmsData: any, countryCode: string) {
  const result = _.find(cmsData, ['country.code', countryCode]);
  const defaultCountryCmsData = _.find(cmsData, ['country.code', ALL_COUNTRY_CODE]);
  if (!result) {
    return defaultCountryCmsData;
  }
  _.map(result, (data, index) => {
    if (!data || data === 'Undefined') {
      _.set(result, index, _.get(defaultCountryCmsData, index, ''));
    }
  });
  return result;
}

export function getCmsDataByIssuerAndDefault(cmsData: any, issuerCode: string) {
  const result = _.find(cmsData, ['vac.code', issuerCode]);
  const defaultIssuerCmsData = _.find(cmsData, ['vac.code', ALL_COUNTRY_CODE]);
  if (!result) {
    return defaultIssuerCmsData;
  }
  _.map(result, (data, index) => {
    if (!data || data === 'Undefined') {
      _.set(result, index, _.get(defaultIssuerCmsData, index, ''));
    }
  });
  return result;
}

export function getVisatypeDocumentUrl(visaSubtype: VisaTypeCMSModel): string {
  if (_.get(visaSubtype, 'visa_types_content.document_link') && _.get(visaSubtype, 'visa_types_content.document_link').startsWith('http')) {
    return _.get(visaSubtype, 'visa_types_content.document_link');
  } else if (_.get(visaSubtype, 'visa_types_content.document.data.url')) {
    return _.get(visaSubtype, 'visa_types_content.document.data.url');
  } else if (visaSubtype.document_link && visaSubtype.document_link.startsWith('http')) {
    return _.get(visaSubtype, 'document_link');
  } else {
    return _.get(visaSubtype, 'document.data.url');
  }
}

/**
 *
 * @param age value in the format of yyyy-mm-dd
 * @returns
 *  If age has not the format of yyyy-mm-dd, return 1000
 *  If age is less than the current date, return the calculated age
 *  If age is greater than the current date, return -1
 */
export function birthAge(age: any) {
  const regex = /^\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])$/;

  if (!regex.test(age)) {
    return 1000;
  }

  let returnAge = 0;
  const strBirthdayArr = age.split('-');
  const birthYear: any = Number(strBirthdayArr[0]);
  const birthMonth: any = Number(strBirthdayArr[1]);
  const birthDay: any = Number(strBirthdayArr[2]);
  const d = new Date();
  const nowYear = d.getFullYear();
  const nowMonth: number = d.getMonth() + 1;
  const nowDay = d.getDate();
  if (nowYear === birthYear) {
    returnAge = 0;
  } else {
    const ageDiff = nowYear - birthYear;
    if (ageDiff > 0) {
      if (nowMonth === birthMonth) {
        const dayDiff = nowDay - birthDay;
        if (dayDiff < 0) {
          returnAge = ageDiff - 1;
        } else {
          returnAge = ageDiff;
        }
      } else {
        const monthDiff = nowMonth - birthMonth;
        if (monthDiff < 0) {
          returnAge = ageDiff - 1;
        } else {
          returnAge = ageDiff;
        }
      }
    } else {
      returnAge = -1;
    }
  }
  return returnAge;
}

export function toFlat(mainArray) {
  let flattened = [];

  for (let subArray of mainArray) {
    for (let item of subArray) {
      flattened.push(item);
    }
  }

  return flattened;
}

export function removeDuplicatedItems(elements) {
  return elements.reduce((acc, current) => {
    const exists = acc.some(item => item.id === current.id);

    if (!exists) acc.push(current);

    return acc;
  }, []);
}

const getRedirectionList = async (): Promise<string[]> => {
  interface directusV9Dto {
    data: {
      name: string;
      values: Array<{
        location: string;
        list_value: string[];
        string_value: null | string;
      }>;
    }[];
  }

  const response = await axios.get<directusV9Dto>(`${DIRECTUS_V9_URL}/items/preferences`, {
    params: {
      fields: ['name', 'values'],
      filter: JSON.stringify({ name: { _eq: 'FORCE_V1_REDIRECTION' } })
    }
  });

  return response.data.data[0].values[0].list_value;
};

export const getRedirectionListCache = (() => {
  let cache: string[] | null = null;

  return async () => {
    if (!cache) {
      try {
        cache = await getRedirectionList();
      } catch (error) {
        location.href = TLSCITIZEN_WEBAPP_URL;
      }
    }

    return cache;
  };
})();

export const ROUTE_MIGRATION_MAP = {
  '/service/:vacId/customer_charter': '/information/service-standard',
  '/service/:countryId': '/country/:countryId',
  '/service/:countryId/:vacId/home': '/country/:countryId/vac/:vacId/',
  '/visa/:vacId/customer_charter': '/information/service-standard',
  '/visa/:countryId': '/country/:countryId',
  '/visa/:countryId/:vacId/home': '/country/:countryId/vac/:vacId/',
  '/security-notice/:countryId/:vacId': '/information/security-notice',
  '/procedure/:countryId/:vacId': '/country/:countryId/vac/:vacId/application-process',
  '/inquiry/:countryId/:vacId': '/country/:countryId/vac/:vacId/contact',
  '/opening-hours/:countryId/:vacId': '/country/:countryId/vac/:vacId/address-opening-hours',
  '/faq/:countryId/:vacId': '/country/:countryId/vac/:vacId/help-centre',
  '/impressum/:countryId/:vacId': '/country/:countryId/vac/:vacId/impressum',
  '/news/:countryId/:vacId': '/country/:countryId/vac/:vacId/news',
  '/travel-insurance/:countryId/:vacId': '/country/:countryId/vac/:vacId/travel-insurance',
  '/added-value-services/:countryId/:vacId': '/country/:countryId/vac/:vacId/services',
  '/olympic_games/:countryId/:vacId': '/country/:countryId/vac/:vacId/olympic-games',
  '/privacy-notice/:countryId/:vacId': '/country/:countryId/vac/:vacId/legal/privacy-policy',
  '/terms-of-service/:countryId/:vacId': '/country/:countryId/vac/:vacId/legal/terms-and-conditions',
  '/terms-of-website-use/:countryId/:vacId': '/country/:countryId/vac/:vacId/legal/terms-of-website-use',
  '/apply_anywhere/:countryId/:vacId': '/',
  '/scamalert/:countryId/:vacId': '/'
};

export const defineCanonicalTag = async (countryId = '-', vacId = '-', formGroupId = '-', to = '/') => {
  if (!IS_FRANCE_CLIENT || !TLSCITIZEN_WEBAPP_URL) {
    return;
  }

  const redirectionList = (await getRedirectionListCache()) || [];

  let canonicalUrl;

  Object.entries(ROUTE_MIGRATION_MAP).forEach(([v1Path, v2Path]) => {
    const currentUrlOrigin = window.location.origin;
    const v1Route = `${currentUrlOrigin}${v1Path}`;
    const v2Route = `${TLSCITIZEN_WEBAPP_URL}${v2Path}`;

    const replacedV1Route = v1Route.replace(':countryId', countryId).replace(':vacId', vacId);
    const replacedV2Route = v2Route
      .replace(':formGroupId', formGroupId)
      .replace(':countryId', countryId)
      .replace(':vacId', vacId);

    if (currentUrlOrigin + to === replacedV1Route) {
      if (redirectionList.includes(countryId) || redirectionList.some(prefix => vacId.startsWith(prefix))) {
        canonicalUrl = replacedV1Route;
      } else {
        canonicalUrl = replacedV2Route;
      }
    }
  });

  if (canonicalUrl) {
    let linkTag = document.querySelector("link[rel='canonical']");

    if (!linkTag) {
      linkTag = document.createElement('link');
      linkTag.setAttribute('rel', 'canonical');
      document.getElementsByTagName('head')[0].appendChild(linkTag);
    }

    linkTag.setAttribute('href', canonicalUrl);
  }
};
